import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "名片管理", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "公司管理", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "产品管理", -1)

import { ref } from 'vue'
import {useRoute} from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'Aside',
  setup(__props) {

const route = useRoute()
const path = route.path
const activeIndex = ref(path)


return (_ctx: any,_cache: any) => {
  const _component_DataAnalysis = _resolveComponent("DataAnalysis")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_User = _resolveComponent("User")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_Postcard = _resolveComponent("Postcard")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_Goods = _resolveComponent("Goods")!
  const _component_Present = _resolveComponent("Present")!
  const _component_Document = _resolveComponent("Document")!
  const _component_ChatLineSquare = _resolveComponent("ChatLineSquare")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, { width: "200px" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "el-menu-vertical-demo",
        style: {"height":"calc(100vh - 60px)"},
        router: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/statistics" }, {
            title: _withCtx(() => [
              _createTextVNode("工作台")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DataAnalysis)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/banners" }, {
            title: _withCtx(() => [
              _createTextVNode("banner图设置")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Picture)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/users" }, {
            title: _withCtx(() => [
              _createTextVNode("管理员管理")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_User)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/members" }, {
            title: _withCtx(() => [
              _createTextVNode("用户管理")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UserFilled)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "/cards" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Postcard)
                ]),
                _: 1
              }),
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/cards" }, {
                default: _withCtx(() => [
                  _createTextVNode("名片管理")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/cards/templet" }, {
                default: _withCtx(() => [
                  _createTextVNode("名片样式")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "/company" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_OfficeBuilding)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/company" }, {
                default: _withCtx(() => [
                  _createTextVNode("公司列表")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/companycates" }, {
                default: _withCtx(() => [
                  _createTextVNode("公司分类")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "/goods" }, {
            title: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Goods)
                ]),
                _: 1
              }),
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/goods" }, {
                default: _withCtx(() => [
                  _createTextVNode("产品列表")
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/cates" }, {
                default: _withCtx(() => [
                  _createTextVNode("产品分类")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/setmeal" }, {
            title: _withCtx(() => [
              _createTextVNode("套餐管理")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Present)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/orders" }, {
            title: _withCtx(() => [
              _createTextVNode("订单管理")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Document)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/qa" }, {
            title: _withCtx(() => [
              _createTextVNode("问题答疑")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ChatLineSquare)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/bidding" }, {
            title: _withCtx(() => [
              _createTextVNode("竞投广告")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Histogram)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _: 1
  }))
}
}

})